export default __webpack_public_path__ + "static/media/hht2_ep06_timeline_09.d2fe2c9f.png";